import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "children"];
import * as React from 'react';
var BreadcrumbSeparator = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    "aria-hidden": true,
    className: className
  }, props), children);
});
BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';
export default BreadcrumbSeparator;